// extracted by mini-css-extract-plugin
export default {"wrapper":"SpeakersTogetherDisplayStyle_wrapper__1eb3k","speakerOffset":"SpeakersTogetherDisplayStyle_speakerOffset__fGzg4"};